import { render, staticRenderFns } from "./StudioSettlement.vue?vue&type=template&id=07d321c0&scoped=true"
import script from "./StudioSettlement.vue?vue&type=script&lang=js"
export * from "./StudioSettlement.vue?vue&type=script&lang=js"
import style0 from "./StudioSettlement.vue?vue&type=style&index=0&id=07d321c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d321c0",
  null
  
)

export default component.exports